import React from 'react';

const PencilSvg = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" {...props} xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <rect width="30" height="30" fill="#000" rx="15" />
                <path
                    fill="#FFF"
                    d="m15.35 8.6 4.3 2.48-5.98 10.37-4.3-2.49zm3.53-3.2 1.7.99c.72.41.97 1.33.55 2.05l-1.25 2.16-4.3-2.48 1.25-2.16a1.5 1.5 0 0 1 2.05-.55Zm-5.5 16.46L9.9 23.98c-.55.33-.83.17-.83-.5l.02-4.1"
                />
            </g>
        </svg>
    );
};

export default PencilSvg;
